import React, {Component, useState, useEffect, Fragment } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import '../../Detail/detail.scss'
import $ from 'jquery';
import classNames from 'classnames';
import API from '../../../config/api';
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import audioPlayIcon from '@/assets/audio_play_icon.png'
import audioPauseIcon from '@/assets/audio_pause_icon.png'
import audioSliderCircleIcon from '@/assets/slider_circle_icon.png'
import { Slider, WingBlank, WhiteSpace } from 'antd-mobile';
const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT', // 图文
  VIDEO: 'VIDEO', // 视频
  SWIPER: 'SWIPER' // 图说
}
class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {}, // 稿件数据，初始化为空对象防止首次渲染报错
      show: false, // 描述展开收起
      playSpeedAry:['1','1.25','1.5','2'], // 播放速度
      curSelectSpeed:'', // 当前选择的倍数
      audioPlayStatus:false,
      audioDuration:'', // 音频总时长
      audioCurTime:0,
    }
  }
  componentWillMount() {
    const data = this.props.data;
    this.setState({
      data,
    }, () => {
      this.initPlayer(data)
      document.title = data.title;
      this.setState({
        title: data.title,
        desc: data.desc,
      })
    })
  }
  
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
  }
  componentWillUnmount() {}
  // 将富文本中的a标签链接替换为当前环境的链接
  replaceHref() {
    console.log("888888888")
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        //替换
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article': // 文章
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video': // 视频
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live': // 直播
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays': // 图说
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial': // 常规专题
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial': // 时间线专题
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial': // 新型专题
            new_href += 'newSubject' + obj.uuid;
            break;
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }
  allaudio() {
    var _this = this;
    // var audios = document.getElementsByClassName('main-text')[0].getElementsByTagName("audio");
    // var audios = $('.main-text audio');
    var audios = $('audio');
    function pauseAll() {
        var self = this;
        console.log(self);
        [].forEach.call(audios, function (i) {
            i !== self && i.pause();
            if(i.id === "namet" && !!i.paused){
              _this.setState({
                audioPlayStatus:false
              })
            }
            // else {
            //   _this.setState({
            //     audioPlayStatus:!_this.state.audioPlayStatus
            //   })
            // }
            console.log(i !== self && i.pause())
        })
    }
    [].forEach.call(audios, function (i) {
        i.addEventListener("play",function(){
          if(i.id === "namet" && i.paused){
            _this.setState({
              audioPlayStatus: true
            })
          }
            console.log(i)
            pauseAll.bind(i)()
        }.bind(i));
    })
  }
  // 初始化视频播放器
  initPlayer = (data) => {
    if (!window.Aliplayer) {
      console.error('Aliplayer 未加载');
      return;
    }
    if (!data || !data.ext_data || !data.ext_data.video_url) {
      console.error('视频地址缺失', data);
      return;
    }
    var player = new window.Aliplayer({
      "id": "player-con",
      "source": data.ext_data.video_url,
      "width": "100%",
      "height": "100%",
      "autoplay": false,
      "isLive": false,
      "rePlay": false,
      "playsinline": true,
      "preload": false,
      "cover": data.cover,
      "controlBarVisibility": "hover",
      "useH5Prism": true,
      "skinLayout": [
        {
          "name": "bigPlayButton",
          "align": "blabs",
          "x": 30,
          "y": 80
        },
        {
          "name": "H5Loading",
          "align": "cc"
        },
        {
          "name": "errorDisplay",
          "align": "tlabs",
          "x": 0,
          "y": 0
        },
        {
          "name": "infoDisplay"
        },
        {
          "name": "tooltip",
          "align": "blabs",
          "x": 0,
          "y": 56
        },
        {
          "name": "thumbnail"
        },
        {
          "name": "controlBar",
          "align": "blabs",
          "x": 0,
          "y": 0,
          "children": [
            {
              "name": "progress",
              "align": "blabs",
              "x": 0,
              "y": 44
            },
            {
              "name": "playButton",
              "align": "tl",
              "x": 15,
              "y": 12
            },
            {
              "name": "timeDisplay",
              "align": "tl",
              "x": 10,
              "y": 7
            },
            {
              "name": "fullScreenButton",
              "align": "tr",
              "x": 10,
              "y": 12
            },
            {
              "name": "volume",
              "align": "tr",
              "x": 5,
              "y": 10
            }
          ]
        }
      ]
    }, function (player) {
        console.log("The player is created");
      }
    );
    this.setState({
      videoPlayer: player
    })
  }
  //点击显示，再次点击隐藏
  MyComponent() {
    this.setState({
      show: !this.state.show,
    })
  }
  
  render() {
    const {uuid, data, audioDuration, audioCurTime, audioPlayStatus, playSpeedAry, curSelectSpeed} = this.state;
    return (
      <Fragment>
        <div style={{color:'#hsl(16.34deg 88.89% 50.59%)',fontSize:'14px', backgroundColor:'hsl(60deg 100% 50.2%)', padding:'10px 0px', textAlign:'center'}}>内部使用，请勿外传</div>
        <div className="video-box"> 
          {/* 视频播放器容器 */}
          <div className="video-container">
            <div id="player-con"></div>
          </div>
          {/* 标题和介绍 */}
          <div className="video-main">
            <div className="video-title" onClick={this.MyComponent.bind(this)}>
              <div className="video-title-content">{data.title}</div>
              <div onClick={this.MyComponent.bind(this)} className={this.state.show ? 'right_downIcon' : 'title-rightIcon'}></div>
            </div>
            <div className="video-authors">{data.head_author}<span style={{ marginLeft: '.2rem' }}>{data.publish_time}</span></div>
            {/* {this.state.show && <div className="video-des" dangerouslySetInnerHTML={{__html: data.desc}}></div>} */}
            {this.state.show && <div key={Date.now()} className="video-des" dangerouslySetInnerHTML={{ __html: data.desc }}></div>}
          </div>

          {/* 分割线 */}
          <div className="empty"></div>
        </div>
      </Fragment>
    )
  }
}
export default Video



// WEBPACK FOOTER //
// ./src/pages/Preview/Video/video.js